export default __webpack_public_path__ + "static/contact-8d155a6855f04538a0688f8fb3753416.png";